import { call, put, takeLatest } from 'redux-saga/effects';
import { Users } from 'services/api';
import {
  generatePassword,
  generatePasswordSuccess,
  generatePasswordFailure,
} from '../../actions';
import { actions as notificationActions } from 'components/Notification';

function* generateNewPassword({ payload }) {
  try {
    const { data } = yield call(Users.generateNewPassword, payload.id, {
      locale: payload.locale,
    });
    yield put(generatePasswordSuccess(data));
    yield put(
      notificationActions.addNotification([
        {
          type: 'success',
          message: { code: 'generated', resource: 'newPassword' },
        },
      ])
    );
  } catch (e) {
    yield put(generatePasswordFailure(e.data));
    yield put(
      notificationActions.addNotification(
        e.data.errors.map(error => ({ type: 'error', message: error.code }))
      )
    );
  }
}

export default () => takeLatest(generatePassword, generateNewPassword);
